import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-portrate'),_c('exports-print',{ref:"exportbar"}),_c('div',[_c('bread-crumbs',{attrs:{"items":_vm.items}}),_c('tabs-comp',{attrs:{"tabs":_vm.tabs}}),_c(VRow,{staticClass:"mt-2 mb-2",staticStyle:{"margin-inline-start":"2px","margin-inline-end":"35px"}},[_c(VCol,{attrs:{"cols":"12"}},[_c('technical-inspection-reports-module')],1)],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }